import { useTranslation } from "react-i18next";
import Select from "react-select";
import CustomButton from "../../../components/button";
import { simpleGetCall, simplePostCall } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import { useEffect, useState } from "react";
import Params from "../../../config/Params";
import useParams from "../../../config/useParams";

function QuizDetails(props) {

    const { validateForm ,selectedAssessmentImprovement,  onAssessmentImprovementChange, handleNext, handleChange, details, assessmentDurationState, isBulk= false, onAssessmentDurationChange , selectedAssessmentDuration} = props

    const [params] = useParams()

    const [isValided, setIsValided] = useState(false)

    const { t } = useTranslation();

    const [gradeOptions, setGradeOptions] = useState([])
    const [curriclumList, setCurriculumList] = useState([])
    const [subjects, setSubjects] = useState([])
    const [syllabusList, setSyllabusList] = useState([])
    const [errors, setErrors] = useState({});
    


    const getSubjectList = (selected_class_division) => {

        let newRequestBody = JSON.stringify({
            customer_id: params.customer_id,
            api_key: params.api_key,
            user_id: params.teacher_id,
            //class_division_id: selected_class_division ? selected_class_division : state.class_division
            class_id: selected_class_division,
        });
        simplePostCall(ApiConfig?.SUBJECT_LIST_BY_SELECTED_GRADE_API, newRequestBody, params).then((res) => {

            if (res?.result) {

                setSubjects(res?.list?.map((subject) => ({
                    label: subject.subject_name,
                    value: subject.subject_id,
                    subject_code: subject.subject_code,
                })
                ))

            }

        })

    }

    const getCurriclumList = () => {

        params.page_limit = 10000000

        simplePostCall(ApiConfig.CURRICULUM_LIST_API, JSON.stringify(params)).then((res) => {

            if (res?.result) {
                let curriclulumOpt = res?.curriculum_list?.map((curriculum) => ({
                    label: curriculum.curriculum_name,
                    value: curriculum.curriculum_id,
                }))

                setCurriculumList(curriclulumOpt)

            }

        })

    }

    const getSyllabusList = () => {

        simplePostCall(ApiConfig?.SYLLABU_TABLE_LIST, JSON.stringify(params)).then((res) => {

            if (res?.result) {

                setSyllabusList(res?.list?.map((syl) => ({
                    label: syl?.curriculum_name + ' - ' + syl.subject_name,
                    value: syl.syllabus_id,
                    data: syl
                })))

            }

        })

    }


    const getClassList = () => {

        let newRequestBody = JSON.stringify({
            customer_id: params.customer_id,
            api_key: params.api_key,
            user_id: params.teacher_id,
        });

        simplePostCall(ApiConfig?.CLASSES_LIST_API, newRequestBody).then((res) => {

            if (res?.result) {
                let gradeOptions = res?.list?.map((grade, index) => {

                    return {
                        label: grade.class_name + " " + grade.class_division_name,
                        value: grade.class_division_id,
                    }

                })

                setGradeOptions(gradeOptions)
            }

        })

    }

    useEffect(() => {
        if (params.api_key) {


            getCurriclumList()
            getSyllabusList()
            getClassList()

            if (details?.grade) {
                getSubjectList(details?.grade)
            }
        }

    }, [params])

    const handleNextStep = () => {

        if( isBulk) {
//             const errors = validateForm(
//   details,
//   selectedAssessmentDuration,
//   selectedAssessmentImprovement
// );

// if (Object.keys(errors).length > 0) {
//   console.log("taleeb_errors---",errors); // show errors
//   setErrors(errors);
// //   return; // stop submit
// }

if (
            !details?.grade ||
            !details?.subject ||
            !details?.curriculum ||
         
            !selectedAssessmentDuration.assessment_duration ||
            !selectedAssessmentImprovement.assessment_improvement ||
            !details.questionScore 
        ||
        (
          details.negative_score === 'yes' &&   !details.negativeScore
        )
        ) {
           
            setIsValided(true)
            return
        }
            handleNext(5);
        } else {

        if (
            !details?.grade ||
            !details?.subject ||
            !details?.curriculum ||
            !details?.syllabus
        ) {
            setIsValided(true)
            return
        }

        handleNext(2)
    }

    }

    const [assessmentImprovementState, setAssessmentImprovementState] = useState({
        assessment_improvements: [
          // { value: '100', label: 'Unlimitted improvement' },
          { value: "0", label: "0 - No more improvement" },
          { value: "1", label: "1 - Improvement" },
          { value: "2", label: "2 - Improvement" },
          { value: "3", label: "3 - Improvement" },
        ],
      });

        const numberOptions = Array.from({ length: 50 }, (_, index) => ({
    value: index + 1,
    label: index + 1,
  }));
    return (

        <div
            style={{ backgroundColor: "white" }}
            className="canLisContentWrap"
        >
            <div className="t-wrapper-div p-4">
                <div className="mb-1">
                    <h5 className="ja-1 mainTitleColr">Assessment Details :</h5>

                </div>
                <div className="row mt-2">
                    <div class="form-group col-md-12">
                        <label for="task-title">{t("Curriculum")}</label>
                        <Select
                            class="js-example-basic-single form-select"
                            value={curriclumList?.filter((cur) => cur.label == details?.curriculumName)}
                            //  defaultValue={{ label: "aatif", value: 0 }}
                            onChange={(e) => {
                                handleChange("curriculum", e.value)
                                handleChange('curriculumName', e.label)
                            }}
                            options={curriclumList}
                        // placeholder={state.curriculum}
                        />
                        <small
                            style={{
                                color: "red",

                            }}
                        >
                            {isValided && !details?.curriculum && "Please Select Curriculum"}
                        </small>
                    </div>
{!isBulk  && (
                    <div class="form-group col-md-12">
                        <label for="task-title">{t("Syllabus")}</label>
                        <Select
                            class="js-example-basic-single form-select"
                            value={syllabusList?.filter((cur) => cur.value == details?.syllabus)}
                            //  defaultValue={{ label: "aatif", value: 0 }}
                            onChange={(e) => handleChange("syllabus", e.value)}
                            options={syllabusList}
                        // placeholder={state.curriculum}
                        />
                        <small
                            style={{
                                color: "red",
                                // display: state.curriculum_error ? "" : "none",
                            }}
                        >
                            {isValided && !details?.syllabus && "Please Select Syllabus"}
                        </small>
                    </div>
)}
                    <div class=" col-md-6 mt-3">
                        <label for="task-title">{t("Grade")}</label>
                        <Select
                            class="js-example-basic-single form-select"
                            value={gradeOptions?.filter((cur) => cur.value == details?.grade)}
                            onChange={(e) => {
                                handleChange("grade", e.value)
                                handleChange("gradeName", e.label)
                                getSubjectList(e.value)

                            }}
                            options={gradeOptions}
                            placeholder={'Select Grade'}
                        />
                        <small
                            style={{
                                color: "red",
                                // display: state.class_division_error ? "" : "none",
                            }}
                        >
                            {isValided && !details?.grade && "Please Select Grade"}
                        </small>
                    </div>

                    <div class=" col-md-6 mt-3">
                        <label for="task-title">{t("Subject")}</label>
                        <Select
                            class="js-example-basic-single form-select"
                            // value={state.selectedSubject}
                            // defaultValue={state.selectedSubject}
                            value={subjects?.filter((cur) => cur.value == details?.subject)}
                            onChange={(e) => {
                                handleChange('selectedLessons', [])
                                handleChange("subject", e.value)
                                handleChange("subjectName", e.label)
                            }}
                            options={subjects}
                        // placeholder={state.subject}
                        />
                        <small
                            style={{
                                color: "red",
                                // display: state.subject_error ? "" : "none",
                            }}
                        >
                            {isValided && !details?.subject && "Please Select Subject"}
                        </small>
                    </div>

{isBulk && (
<>
    <div class=" col-md-6 mt-3">
                      <label for="task-title">
                        {t("Assessment Duration (Minutes)")}
                      </label>
                      <Select
                        class="js-example-basic-single form-select"
                        value={selectedAssessmentDuration.selectedAssessmentDuration}
                        onChange={onAssessmentDurationChange}
                        options={assessmentDurationState.duration_list}
                        placeholder={"Select"}
                      />
                        <small
                            style={{
                                color: "red",
                                // display: state.subject_error ? "" : "none",
                            }}
                        >
                            {isValided && !selectedAssessmentDuration?.assessment_duration && "Please Select Duration"}
                        </small>
                    </div>



                   <div class=" col-md-6 mt-3">
                      <label for="task-title">
                        {t("Assessment Improvement")}
                      </label>
                      <Select
                        class="js-example-basic-single form-select"
                        value={selectedAssessmentImprovement.selectedAssessmentImprovement}
                        onChange={onAssessmentImprovementChange}
                        options={
                          assessmentImprovementState.assessment_improvements
                        }
                        // placeholder={(() => {
                        //   switch (state.assessment_improvement) {
                        //     case 0:
                        //       return t("No more improvement");
                        //     case 1:
                        //       return t("1 - Improvement");
                        //     case 2:
                        //       return t("2 - Improvement");
                        //     case 3:
                        //       return t("3 - Improvement");
                        //     default:
                        //       return null;
                        //   }
                        // })()}
                      />
                       <small
                            style={{
                                color: "red",
                                // display: state.subject_error ? "" : "none",
                            }}
                        >
                            {isValided && !selectedAssessmentImprovement?.assessment_improvement && "Please Select Assessment Improvement"}
                        </small>
                    </div>

                    <div className="col-md-6 mt-3">
  <label htmlFor="difficultyDropdown">{t("Difficulty")}</label>

 <Select
  className="js-example-basic-single"
  value={{
    value: details.difficulty || "easy",
    label:
      details.difficulty === "easy"
        ? "Easy"
        : details.difficulty === "medium"
        ? "Moderate"
        : "Tough",
  }}
  onChange={(selectedOption) =>
    handleChange("difficulty", selectedOption.value)
  }
  options={[
    { value: "easy", label: "Easy" },
    { value: "medium", label: "Moderate" },
    { value: "hard", label: "Tough" },
  ]}
  placeholder="Select"
/>
</div>

<div className="col-md-6 mt-3">
  <label htmlFor="questionScore">{t("Score Per Question")}</label>

  <input
    type="number"
    id="questionScore"
    className="form-control"
    value={details.questionScore}
    onChange={(e) => handleChange("questionScore", e.target.value)}
    min={0}
    placeholder={t("Enter score")}
  />

     <small
                            style={{
                                color: "red",
                                // display: state.subject_error ? "" : "none",
                            }}
                        >
                            {isValided && !details?.questionScore && "Please Enter Score"}
                        </small>
</div>

  <div class=" col-md-6 mt-3">
                      <label for="task-title">{t("Negative Score")}</label>
                      <div class="form-control">
                        <input
                          type={"radio"}
                          name="negative_score"
                          value="yes"
                          onChange={(e) => {
                            handleChange('negative_score' , e.target.value)
                          
                          }}
                          checked={
                            details.negative_score == "yes"
                            //  ||
                            //   state.assessment_negative_marks == "yes"
                              ? true
                              : false
                          }
                        />
                        {" "}
                        {t("Yes")} &nbsp;&nbsp;&nbsp;
                        <input
                          type={"radio"}
                          name="negative_score"
                          value="no"
                          onChange={(e) => {
                  
                            handleChange('negative_score' , e.target.value)
                          
                         
                          }}
                          checked={
                            details.negative_score == "no" 
                            // ||
                            //   state.assessment_negative_marks == "no"
                              ? true
                              : false
                          }
                        />{" "}
                        {t("No")}
                      </div>
                      <small style={{ color: "red", display: "none" }}>
                        { }
                      </small>
                    </div>

                    {details.negative_score === "yes" && (
  <div className="col-md-6 mt-3">
    <label htmlFor="negativeScore">{t("Negative Score Per Question")}</label>

    <input
      type="number"
      id="negativeScore"
      className="form-control"
      value={details.negativeScore}
      onChange={(e) =>
        handleChange("negativeScore", e.target.value)
      }
      min={0}
      placeholder={t("Enter negative score")}
    />

       <small
                            style={{
                                color: "red",
                                // display: state.subject_error ? "" : "none",
                            }}
                        >
                            {isValided && !details?.negativeScore && "Please Enter Negative Score"}
                        </small>
  </div>
)}

                        <div className="col-md-6 mt-3">
      <label htmlFor="numberDropdown">{t("Number of Questions")}</label>
    
        <Select
             class="js-example-basic-single form-select"
          value={numberOptions.find(option => option.value === details.number_of_question)}
          onChange={(selectedOption) => handleChange('number_of_question', selectedOption.value)}
          options={numberOptions}
          placeholder="Select"
        />
   
    </div>
</>
)}
                </div>

                <div className="question-modal-footer d-flex justify-content-end gap-2 mt-3">
                    <CustomButton
                        isLoading={false}
                        title="Back"
                        buttonType="secondary"
                        handleClick={() => { handleNext(1) }}
                    />
                    <CustomButton
                        title={isBulk ? "Generate Questions" : "Next"}
                        isLoading={false}
                        handleClick={handleNextStep}
                    />
                </div>
            </div>
        </div>

    )

}

export default QuizDetails